export const withLifecycleRules = resolver => ({
  name: `withLifecycleRules > ${resolver.name}`,
  attach: (params, runtime) => {
    let detached = false;
    const lifecycle = resolver.attach(params, Object.assign({}, runtime, {
      next: state => {
        if (!detached) {
          runtime.next(state);
        }
      }
    }));
    return Object.assign({}, lifecycle, {
      detach: () => {
        lifecycle.detach();
        detached = true;
      }
    });
  }
});